"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var Subject_1 = require("rxjs/Subject");
var material_1 = require("@angular/material");
var idm_de_service_client_js_1 = require("@synisys/idm-de-service-client-js");
var idm_dynamic_forms_ui_1 = require("@synisys/idm-dynamic-forms-ui");
var operators_1 = require("rxjs/operators");
var custom_table_action_provider_service_1 = require("../../../../shared/services/api/custom-table-action-provider.service");
var confirm_dialog_component_1 = require("../../../../shared/dialogs/confirm/confirm-dialog.component");
var dialog_config_helper_1 = require("../../../../shared/utils/dialog-config-helper");
var of_1 = require("rxjs/observable/of");
var zip_1 = require("rxjs/observable/zip");
var bulk_picker_action_context_1 = require("../../model/bulk-picker-action-context");
var TableEntityActionsComponent = /** @class */ (function () {
    function TableEntityActionsComponent(dialog, customTableActionProviderService) {
        this.dialog = dialog;
        this.customTableActionProviderService = customTableActionProviderService;
        this.afterAction = new core_1.EventEmitter();
        this.hovered$ = new Subject_1.Subject();
        this._destroy$ = new Subject_1.Subject();
    }
    TableEntityActionsComponent.prototype.ngOnChanges = function (changes) {
        if (changes['hovered'] && this.hovered) {
            this.hovered$.next(true);
        }
    };
    TableEntityActionsComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.hovered$
            .debounceTime(300)
            .takeUntil(this._destroy$)
            .subscribe(function () {
            return _this.visibleActions$ = _this.customActions.length ? _this.getVisibleActions() : of_1.of([]);
        });
    };
    TableEntityActionsComponent.prototype.ngOnDestroy = function () {
        this._destroy$.next(true);
        this._destroy$.complete();
    };
    TableEntityActionsComponent.prototype.onEdit = function () {
        var _this = this;
        this._isEditAction = true;
        this.form.actionNotifier
            .takeUntil(this._destroy$)
            .subscribe(function (formAction) {
            if (_this._isEditAction) {
                var isSubFormSaveAction = formAction.key === idm_dynamic_forms_ui_1.ActionNotifierKey.SUB_FORM_SAVE_ACTION;
                var isSubFormCloseAction = formAction.key === idm_dynamic_forms_ui_1.ActionNotifierKey.SUB_FORM_CLOSE_ACTION;
                if (isSubFormSaveAction || isSubFormCloseAction) {
                    _this._isEditAction = false;
                    isSubFormSaveAction && _this.afterAction.emit(_this.subEntity.getId());
                }
            }
        });
        this.form.actions.openEditPopup(this.form, this.subEntityCategoryId, '', this.subEntity.clone(), this.editFormId);
    };
    TableEntityActionsComponent.prototype.onDelete = function () {
        var _this = this;
        this.dialog.open(confirm_dialog_component_1.ConfirmDialogComponent, dialog_config_helper_1.DialogConfigHelper.getConfirmationDialogConfig('ejustice_delete_popup_title', 'ejustice_delete_warning', null, 'ejustice_yes', 'ejustice_no')).afterClosed()
            .pipe(operators_1.takeUntil(this._destroy$))
            .subscribe(function (result) {
            if (result) {
                var subEntities = _this.entity.getProperty(_this.subEntityCategoryId).value;
                subEntities.splice(subEntities.indexOf(_this.subEntity), 1);
                _this.afterAction.emit(_this.subEntity.getId());
            }
        });
    };
    TableEntityActionsComponent.prototype.onCustomAction = function (actionKey) {
        var _this = this;
        this.customTableActionProviderService.provideAction(actionKey, this.subEntity, new bulk_picker_action_context_1.BulkPickerActionContext(this.entity, this.form, this.categoryId, this.subEntityCategoryId))
            .pipe(operators_1.takeUntil(this._destroy$), operators_1.take(1))
            .subscribe(function () { return _this.afterAction.emit(_this.subEntity.getId()); });
    };
    TableEntityActionsComponent.prototype.getVisibleActions = function () {
        var _this = this;
        if (this.customTableActionProviderService) {
            var actionsWithDeterminedVisibility$ = this.customActions.map(function (action) {
                return _this.customTableActionProviderService.provideVisibility(action.actionKey, _this.subEntity, new bulk_picker_action_context_1.BulkPickerActionContext(_this.entity, _this.form, _this.categoryId, _this.subEntityCategoryId))
                    .map(function (isVisible) { return ({ isVisible: isVisible, config: action }); });
            });
            return zip_1.zip.apply(void 0, actionsWithDeterminedVisibility$).map(function (actions) {
                var visibleActions = [];
                actions.forEach(function (action) {
                    if (action.isVisible) {
                        visibleActions.push(action.config);
                    }
                });
                return visibleActions;
            });
        }
        return of_1.of([]);
    };
    __decorate([
        core_1.Input(),
        __metadata("design:type", idm_de_service_client_js_1.MainEntity)
    ], TableEntityActionsComponent.prototype, "entity", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Number)
    ], TableEntityActionsComponent.prototype, "currentLanguageId", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", idm_de_service_client_js_1.SubEntity)
    ], TableEntityActionsComponent.prototype, "subEntity", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", idm_dynamic_forms_ui_1.DynamicFormComponent)
    ], TableEntityActionsComponent.prototype, "form", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], TableEntityActionsComponent.prototype, "categoryId", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], TableEntityActionsComponent.prototype, "subEntityCategoryId", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Number)
    ], TableEntityActionsComponent.prototype, "editFormId", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Array)
    ], TableEntityActionsComponent.prototype, "customActions", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], TableEntityActionsComponent.prototype, "rootTableTitle", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Boolean)
    ], TableEntityActionsComponent.prototype, "showDeleteButton", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Boolean)
    ], TableEntityActionsComponent.prototype, "hovered", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], TableEntityActionsComponent.prototype, "idPrefix", void 0);
    __decorate([
        core_1.Output(),
        __metadata("design:type", core_1.EventEmitter)
    ], TableEntityActionsComponent.prototype, "afterAction", void 0);
    TableEntityActionsComponent = __decorate([
        core_1.Component({
            selector: 'ejustice-table-entity-actions',
            styles: [require('./table-entity-actions.component.css')],
            template: require('./table-entity-actions.component.html')
        }),
        __param(1, core_1.Optional()),
        __metadata("design:paramtypes", [material_1.MatDialog, custom_table_action_provider_service_1.CustomTableActionProviderService])
    ], TableEntityActionsComponent);
    return TableEntityActionsComponent;
}());
exports.TableEntityActionsComponent = TableEntityActionsComponent;
//# sourceMappingURL=table-entity-actions.component.js.map